var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCToken(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 10,
    fill: "#5653FC",
    fillOpacity: 0,
    shapeRendering: "crispEdges"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 9.5,
    stroke: "#5653FC",
    shapeRendering: "crispEdges"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "C",
    d: "M14.016 18.8107C13.16 18.8107 12.384 18.6267 11.688 18.2587C11 17.8827 10.456 17.3667 10.056 16.7107C9.664 16.0467 9.468 15.2987 9.468 14.4667C9.468 13.6347 9.664 12.8907 10.056 12.2347C10.456 11.5707 11 11.0547 11.688 10.6867C12.384 10.3107 13.164 10.1227 14.028 10.1227C14.756 10.1227 15.412 10.2507 15.996 10.5067C16.588 10.7627 17.084 11.1307 17.484 11.6107L16.236 12.7627C15.668 12.1067 14.964 11.7787 14.124 11.7787C13.604 11.7787 13.14 11.8947 12.732 12.1267C12.324 12.3507 12.004 12.6667 11.772 13.0747C11.548 13.4827 11.436 13.9467 11.436 14.4667C11.436 14.9867 11.548 15.4507 11.772 15.8587C12.004 16.2667 12.324 16.5867 12.732 16.8187C13.14 17.0427 13.604 17.1547 14.124 17.1547C14.964 17.1547 15.668 16.8227 16.236 16.1587L17.484 17.3107C17.084 17.7987 16.588 18.1707 15.996 18.4267C15.404 18.6827 14.744 18.8107 14.016 18.8107Z",
    fill: "#5653FC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCToken);
export default __webpack_public_path__ + "static/media/cToken.5903628014cb2ffbc6f7bace9be5e4fb.svg";
export { ForwardRef as ReactComponent };